module.exports = __webpack_public_path__ + "static/media/longest-drive.3ee96d25.png";